<template>
  <SelectItem
    :value="item.id"
    class="group w-full md:h-11 flex items-center justify-between grow py-2 ltr:pr-4 rtl:pl-4 ltr:pl-2 rtl:pr-2 md:p-[3px] ltr:md:pr-4 rtl:md:pl-4 gap-2 rounded-xl hover:cursor-pointer transition duration-400 ease-out"
    :class="{
      'bg-alpha-white-10': active && variant === 'on-brand',
      'hover:bg-alpha-white-10': variant === 'on-brand',
      'bg-utility-gray-100': active && variant === 'white',
      'hover:bg-utility-gray-100': variant === 'white',
    }"
  >
    <div class="flex items-center grow gap-2 overflow-hidden">
      <Indicator
        variant="building"
        :size="maxSmall ? 'md' : 'sm'"
        mode="solid"
        :imageUrl="item?.imageUrl"
        alpha
        :isGroup="isGroup"
      />
      <span
        :title="item.name"
        class="text-style-base md:text-style-sm font-medium truncate"
        :class="{
          'text-primary_on-brand': variant === 'on-brand',
          'text-primary': variant === 'white',
        }"
      >
        <slot>
          {{ item.name }}
        </slot>
      </span>
    </div>
  </SelectItem>
</template>

<script setup>
import { SelectItem } from "radix-vue";
import { Indicator } from "@/SharedComponents/Indicator";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineProps({
  item: { type: Object, required: true },
  active: { type: Boolean, required: false },
  variant: { type: String, default: "on-brand" },
  isGroup: { type: Boolean, default: false },
});
</script>
